module.exports = __webpack_public_path__ + "static/img/FITmenu04.f39a046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu04.png
// module id = 5eOa
// module chunks = 1